import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { IApplicationState } from 'components/store/types'
import { getRegionCliniques } from 'components/core/state/selectors'
import Container from 'components/ui/Container'
import CliniquesList from 'components/ui/CliniquesList'
import GoogleMapWrapper from 'components/maps/GoogleMapWrapper'

const mapState = (state: IApplicationState) => ({
  cliniques: getRegionCliniques(state),
})
const connector = connect(mapState)

const Step2MapDesktop = ({ cliniques }: ConnectedProps<typeof connector>) => (
  <Container>
    <div className="tw-col-span-5">
      <CliniquesList cliniques={cliniques} />
    </div>
    <div className="tw-col-span-7">
      <GoogleMapWrapper />
    </div>
  </Container>
)
export default connector(Step2MapDesktop)
